import React from 'react';
import FixedBottomNavBar from '../../../../components/FixedBottomNavBar';
import Button from '../../../../components/Button';
import './CouponGenerateNavbar.scss';

const CouponGenerateNavbar = (props) => {
  const { toggleModal, onSubmit } = props;

  return (
    <FixedBottomNavBar className="coupon-generate-navbar">
      {/*발급*/}
      <Button
        color="primary"
        text="엑셀일괄발급"
        onClick={() =>
          toggleModal({
            name: 'excelBulkGenerateCouponModal',
            value: true,
          })
        }
      />

      {/*발급*/}
      <Button color="primary" text="발급" onClick={() => onSubmit()} />
    </FixedBottomNavBar>
  );
};

export default CouponGenerateNavbar;
